import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiPrivateService } from "api/api";
import {
  buildFormData,
  uploadAllFiles,
} from "redux/actioncreators/interPaymentUploadHelpers";
import { siteSlice } from "redux/reducers/SiteSlice";

export const fetchInterPaymentForEdit = createAsyncThunk<
  { data: any },
  number,
  { rejectValue: string }
>("data/fetchInterPaymentForEdit", async (id: number, thunkAPI) => {
  console.log("📤 Thunk: fetchInterPaymentForEdit started for ID:", id);
  try {
    const response = await apiPrivateService.get(
      `/international-payments/${id}`,
    );

    console.log("📥 Raw API response:", response?.data);

    const item =
      response?.data?.data?.international_payment ??
      response?.data?.data ??
      response?.data ??
      null;
    if (!item) {
      throw new Error("No data received");
    }
    const parseArr = (maybeJson: any) => {
      if (typeof maybeJson === "string") {
        try {
          const arr = JSON.parse(maybeJson);
          return Array.isArray(arr) ? arr : [];
        } catch {
          return [];
        }
      }
      return Array.isArray(maybeJson) ? maybeJson : [];
    };
    const parsedItem = {
      ...item,
      payee_documents: parseArr(item?.payee_documents),
      payer_documents: parseArr(item?.payer_documents),
    };
    console.log("📥 Thunk: fetch success, parsedItem:", parsedItem);
    return { data: parsedItem };
  } catch (e: any) {
    console.log("❌ Thunk: fetch error:", e);
    return thunkAPI.rejectWithValue(e?.message || "Fetch failed");
  }
});

interface UpdateInterPaymentArg {
  id: number;
  data: any;
}
export const updateInterPayment = createAsyncThunk<
  { data: any },
  { id: number; data: any },
  { rejectValue: string }
>("data/updateInterPayment", async ({ id, data }, thunkAPI) => {
  thunkAPI.dispatch(siteSlice.actions.setFilesUploading(true));

  try {
    // 1. Загружаем новые файлы (FileList) → получаем id
    const uploadedMap = await uploadAllFiles(data);

    thunkAPI.dispatch(siteSlice.actions.setFilesUploading(false));

    // 2. Собираем FormData с id вместо FileList + _method: PUT
    const formData = buildFormData(data, uploadedMap);
    formData.append("_method", "PUT");

    // 3. POST с _method:PUT на v2
    const response = await apiPrivateService.post(
      `/v2/international-payments/${id}`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } },
    );

    const updatedItem = response?.data?.data;
    if (!updatedItem) throw new Error("Update failed");

    return { data: updatedItem };
  } catch (e: any) {
    thunkAPI.dispatch(siteSlice.actions.setFilesUploading(false));
    return thunkAPI.rejectWithValue(e?.message || "Update failed");
  }
});
